export default {
  beforeRouteEnter (to, from, next) {
    window.document.body.style.background = '#fff'
    next()
  },
  beforeRouteLeave (to, from, next) {
    window.document.body.style.background = ''
    next()
  }
}
